module.exports = __webpack_public_path__ + "static/media/Ellipse 10.9c916686.png";